export default __webpack_public_path__ + "static/media/grupo_excel_fondo_blanco.ac36f67c.jpg";